import React from "react";
import ChannelSubEconomySettings from "@/components/ChannelSubEconomySettings";
import ChannelChatSettings from "@/components/ChannelChatSettings";
import { Gem } from "lucide-react";
import { SectionBlock } from "./Channel";

/**
 * Subscriptions — pricing, sub-only chat, sub emotes. Wraps the two existing
 * per-channel settings components so the streamer sees them under one roof
 * without duplicated markup.
 */
export default function Subscriptions() {
  return (
    <div className="space-y-6 max-w-4xl" data-testid="section-subscriptions">
      <SectionBlock icon={Gem} title="Subscription Economy" color="pink">
        <ChannelSubEconomySettings />
      </SectionBlock>

      <SectionBlock icon={Gem} title="Chat Access" color="cyan">
        <ChannelChatSettings />
      </SectionBlock>

      <div className="term-card p-4 border-dashed" data-testid="subs-roadmap">
        <div className="sc-label mb-2" style={{ color: "var(--sc-orange)" }}>◈ ROADMAP</div>
        <ul className="text-xs text-zinc-400 space-y-1.5">
          <li>• Multi-tier subscriptions with custom perks</li>
          <li>• Founder / loyalty badges</li>
          <li>• Gift-sub packs</li>
          <li>• Welcome-message templates per tier</li>
        </ul>
        <div className="text-[10px] text-zinc-500 mt-3">These arrive in Phase 2.</div>
      </div>
    </div>
  );
}
